export default class FontSizeController {
  
  constructor() {
    this.thisHTML = document.querySelector('html');
    this.options = document.querySelectorAll('.content-panel-accessibility__font-size a');
    this.handleFontSize = this.handleFontSize.bind(this);

    this.options.forEach((option) => {
      option.addEventListener('click', this.handleFontSize );
    });

    this.checkLocalStorage();

  }

  handleFontSize(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const set = target.getAttribute('data-set');
    this.addClass(target);
    this.thisHTML.setAttribute('data-font-size', set);
    this.setLocalStorage();
  }

  addClass(selectedElement) {
    this.resetSelected();
    selectedElement.classList.add('is-selected');
  }

  resetSelected() {
    this.options.forEach( item => {
      item.classList.remove('is-selected');
    });
  }

  setLocalStorage() {
    const thisHTML = document.querySelector('html');
    localStorage.setItem('fontSize', thisHTML.getAttribute('data-font-size'));
  }

  checkLocalStorage() {
    const fontSize = localStorage.getItem('fontSize');
    this.thisHTML.setAttribute('data-font-size', fontSize);
    let selectedOption = document.querySelector(`.content-panel-accessibility__font-size a[data-set="${fontSize}"]`);
    if (!selectedOption) {
      selectedOption = document.querySelector(`.content-panel-accessibility__font-size a[data-set="medium"]`);
    }
    this.addClass(selectedOption);
  }
}